// Match Types — prices vary by difficulty
// Easy/Normal/Hard use price_standard
// Extreme/Immortal use price_extreme (x1.25)

export const MATCH_TYPES = [
  { id: 'normal', name: 'Normal', price_standard: 0, price_extreme: 0 },
  { id: 'tables', name: 'Tables', price_standard: 5000, price_extreme: 6000 },
  { id: 'ladder', name: 'Ladder', price_standard: 10000, price_extreme: 12000 },
  { id: 'extreme-rules', name: 'Extreme Rules', price_standard: 15000, price_extreme: 18000 },
  { id: 'last-man-standing', name: 'Last Man Standing', price_standard: 15000, price_extreme: 18000 },
  { id: 'underground', name: 'Underground', price_standard: 15000, price_extreme: 18000 },
  { id: 'iron-man', name: 'Iron Man', price_standard: 20000, price_extreme: 25000 },
  { id: 'tlc', name: 'TLC', price_standard: 20000, price_extreme: 24000 },
  { id: 'falls-count-anywhere', name: 'Falls Count Anywhere', price_standard: 25000, price_extreme: 30000 },
  { id: 'submission', name: 'Submission', price_standard: 25000, price_extreme: 30000 },
  { id: 'tornado-tag', name: 'Tornado Tag', price_standard: 25000, price_extreme: 30000 },
  { id: 'ambulance', name: 'Ambulance', price_standard: 30000, price_extreme: 36000 },
  { id: 'special-guest-referee', name: 'Special Guest Referee', price_standard: 30000, price_extreme: 36000 },
  { id: 'gauntlet', name: 'Gauntlet', price_standard: 30000, price_extreme: 36000 },
  { id: 'steel-cage', name: 'Steel Cage', price_standard: 35000, price_extreme: 42000 },
  { id: 'battle-royal', name: 'Battle Royal', price_standard: 35000, price_extreme: 42000 },
  { id: 'hell-in-a-cell', name: 'Hell in A Cell', price_standard: 40000, price_extreme: 48000 },
  { id: 'bloodline-rules', name: 'Bloodline Rules', price_standard: 40000, price_extreme: 48000 },
  { id: 'no-holds-barred', name: 'No Holds Barred', price_standard: 45000, price_extreme: 54000 },
  { id: 'dumpster', name: 'Dumpster', price_standard: 45000, price_extreme: 54000 },
  { id: 'three-stage-of-hell', name: 'Three Stage of Hell', price_standard: 50000, price_extreme: 54000 },
  { id: 'gauntlet-eliminator', name: 'Gauntlet Eliminator', price_standard: 50000, price_extreme: 54000 },
  { id: 'backstage-brawl', name: 'Backstage Brawl', price_standard: 60000, price_extreme: 72000 },
  { id: 'inferno', name: 'Inferno', price_standard: 65000, price_extreme: 78000 },
  { id: 'casket', name: 'Casket', price_standard: 75000, price_extreme: 90000 },
  { id: 'i-quit', name: 'I Quit', price_standard: 75000, price_extreme: 90000 },
];

export const MATCH_RULES = [
  { id: '1v1', name: 'One Vs. One', description: '1 vs 1' },
  { id: 'tag', name: 'Tag Team', description: '2 vs 2' },
  { id: 'triple-threat', name: 'Triple Threat', description: '1 vs 1 vs 1' },
  { id: 'fatal-4-way', name: 'Fatal 4-Way', description: '1 vs 1 vs 1 vs 1' },
  { id: 'five-way', name: '5-Way', description: '1 vs 1 vs 1 vs 1 vs 1' },
  { id: 'six-way', name: '6-Way', description: '1 vs 1 vs 1 vs 1 vs 1 vs 1' },
  { id: '3v3', name: 'Three Vs Three', description: '3 vs 3' },
  { id: 'tag-triple-threat', name: 'TagTeam Triple Threat', description: '2 vs 2 vs 2' },
  { id: 'eight-way', name: '8-Way', description: '1 vs 1 vs 1 vs 1 vs 1 vs 1 vs 1 vs 1' },
  { id: '4v4', name: 'Four Vs. Four', description: '4 vs 4' },
  { id: 'tag-fatal-4-way', name: 'TagTeam Fatal 4-Way', description: '2 vs 2 vs 2 vs 2' },
  { id: '1v2', name: 'One Vs. Two', description: '1 vs 2' },
  { id: '1v3', name: 'One Vs. Three', description: '1 vs 3' },
  { id: '2v3', name: 'Two Vs. Three', description: '2 vs 3' },
];

// Difficulty multiplier for match prices
export const DIFFICULTY_PRICE_MULTIPLIER = {
  easy: 1,
  normal: 1,
  hard: 1,
  extreme: 1.25,
  immortal: 1.25,
};



// ── Show Structure by Difficulty ───────────────────────────────────
// O = Opener, M = Mid Match, P = Promo, ME = Main Event

export const SHOW_STRUCTURE = {
  easy: {
    weekly:  ['opener', 'promo', 'mid', 'promo', 'main_event'],
    gohome:  ['opener', 'promo', 'mid', 'promo', 'mid', 'promo', 'main_event'],
    priceMode: 'standard',
  },
  normal: {
    weekly:  ['opener', 'promo', 'mid', 'promo', 'mid', 'promo', 'main_event'],
    gohome:  ['opener', 'promo', 'mid', 'promo', 'mid', 'promo', 'mid', 'promo', 'main_event'],
    priceMode: 'standard',
  },
  hard: {
    weekly:  ['opener', 'promo', 'mid', 'promo', 'mid', 'promo', 'main_event'],
    gohome:  ['opener', 'promo', 'mid', 'promo', 'mid', 'promo', 'mid', 'promo', 'main_event'],
    priceMode: 'standard',
  },
  extreme: {
    weekly:  ['opener', 'promo', 'mid', 'promo', 'mid', 'promo', 'mid', 'promo', 'main_event'],
    gohome:  ['opener', 'promo', 'mid', 'promo', 'mid', 'promo', 'mid', 'promo', 'main_event'],
    priceMode: 'extreme',
  },
  immortal: {
    weekly:  ['opener', 'promo', 'mid', 'promo', 'mid', 'promo', 'mid', 'promo', 'main_event'],
    gohome:  ['opener', 'promo', 'mid', 'promo', 'mid', 'promo', 'mid', 'promo', 'main_event'],
    priceMode: 'extreme',
  },
};

export const SLOT_LABELS = {
  opener: 'OPENER',
  mid: 'MID MATCH',
  main_event: 'MAIN EVENT',
  promo: 'PROMO',
};

export const SLOT_COLORS = {
  opener: '#3498db',
  mid: '#2ecc71',
  main_event: '#e74c3c',
  promo: '#d4af37',
};

export const DIFFICULTIES = [
  { key: 'easy', label: 'EASY', color: '#2ecc71', description: 'Fewer slots, standard prices' },
  { key: 'normal', label: 'NORMAL', color: '#3498db', description: 'Standard slots and prices' },
  { key: 'hard', label: 'HARD', color: '#e67e22', description: 'More slots, standard prices' },
  { key: 'extreme', label: 'EXTREME', color: '#e74c3c', description: 'Max slots, extreme prices' },
  { key: 'immortal', label: 'IMMORTAL', color: '#9b59b6', description: 'Max slots, extreme prices, no mercy' },
];

// Get match price based on difficulty
export const getMatchPrice = (matchTypeId, difficulty = 'normal') => {
  const match = MATCH_TYPES.find(m => m.id === matchTypeId);
  if (!match) return 0;
  const mode = SHOW_STRUCTURE[difficulty]?.priceMode || 'standard';
  return mode === 'extreme' ? match.price_extreme : match.price_standard;
};

// Get show structure for a given week and difficulty
export const getShowStructure = (week, difficulty = 'normal') => {
  const struct = SHOW_STRUCTURE[difficulty] || SHOW_STRUCTURE.normal;
  const isGoHome = week % 5 === 4;
  const isPLE = week % 5 === 0;
  if (isPLE) return null; // PLE structure TBD
  return isGoHome ? struct.gohome : struct.weekly;
};

// ── Match Types available per Match Rule ────────────────────────────
export const MATCH_TYPES_BY_RULE = {
  '1v1':              ['normal','tables','ladder','extreme-rules','last-man-standing','iron-man','tlc','falls-count-anywhere','submission','ambulance','special-guest-referee','underground','steel-cage','hell-in-a-cell','bloodline-rules','no-holds-barred','dumpster','three-stage-of-hell','backstage-brawl','inferno','casket','i-quit'],
  'tag':              ['normal','tables','ladder','extreme-rules','tlc','tornado-tag','steel-cage','hell-in-a-cell','backstage-brawl'],
  'triple-threat':    ['normal','tables','ladder','extreme-rules','tlc','falls-count-anywhere','steel-cage','hell-in-a-cell','backstage-brawl'],
  'fatal-4-way':      ['normal','tables','ladder','extreme-rules','tlc','falls-count-anywhere','gauntlet','steel-cage','battle-royal','hell-in-a-cell','gauntlet-eliminator','backstage-brawl'],
  'five-way':         ['normal','tables','ladder','extreme-rules','tlc','gauntlet','battle-royal','hell-in-a-cell','gauntlet-eliminator'],
  'six-way':          ['normal','ladder','gauntlet','battle-royal','hell-in-a-cell','gauntlet-eliminator','backstage-brawl'],
  '3v3':              ['normal','tables','ladder','tlc','tornado-tag','hell-in-a-cell'],
  'eight-way':        ['normal','ladder','gauntlet','battle-royal','gauntlet-eliminator','backstage-brawl'],
  '4v4':              ['ladder','tornado-tag'],
  'tag-triple-threat':['tables','ladder','tlc','hell-in-a-cell','tornado-tag'],
  'tag-fatal-4-way':  ['ladder','tornado-tag'],
  '1v2':              ['normal','tornado-tag','backstage-brawl'],
  '1v3':              ['normal'],
  '2v3':              ['normal'],
};

// Get available match types for a given rule
export const getMatchTypesForRule = (ruleId) => {
  const allowed = MATCH_TYPES_BY_RULE[ruleId] || ['normal'];
  return MATCH_TYPES.filter(m => allowed.includes(m.id));
};
